import { PackingBOMStatusEnum } from "@gtpl/shared-models/common-models";
import { SoNumbersResponseModel } from "@gtpl/shared-models/sale-management";
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToOne } from "typeorm";

@Entity('packing_bom_log')
export class PackingBomLog {

    @PrimaryGeneratedColumn("increment", { name: 'packing_bom_log_id' })
    bomLogId: number;
    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: false,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;
    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;
    @Column("int", {
        nullable: false,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int",{
        nullable: false,
        name: "quantity",
        // default: 0,
    })
    quantity: number;
    @Column({
        type: 'enum',
        nullable: true,
        enum: PackingBOMStatusEnum,
        default:PackingBOMStatusEnum.OPEN,
        name: "status"
      })
      status: PackingBOMStatusEnum;
      @Column("boolean", {
        nullable: false,
        default: false,
        name: "is_grn"
    })
    isGrn: boolean;
    @Column("boolean", {
        nullable: false,
        default: false,
        name: "is_assigned"
    })
    isAssigned: boolean;
    @Column("int",{
        nullable: false,
        name: "po_quantity",
        default: 0,
    })
    poQuantity: number;
    @Column("int",{
        nullable: false,
        name: "grn_quantity",
        default: 0,
    })
    grnQuantity: number;
    @Column("int",{
        nullable: false,
        name: "assigned_quantity",
        default: 0,
    })
    assignedQuantity: number;
    @Column("varchar", {
        nullable: false,
        name: "barcode",
        length:155,
      })
      barcode: string;
      @Column("int", {
        nullable: false,
        name: "ref_no",
      })
      refNumber: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;
    @Column("varchar", {
        nullable: false,
        default: "Admin",
        name: "created_user"
    })
    createdUser: string | null;
    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;
    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    //   @ManyToOne(type=>SaleOrder, saleOrder=>saleOrder.BomDetailsInfo, {  nullable:false })
    //   @JoinColumn({ name:"sale_order_id"})
    //   saleOrderInfo: SaleOrder;
}
